<template>
	<v-autocomplete
		:items="items"
		:label="label"
		:disabled="disabled"
		:multiple="multiple"
		:value="selected"
		:clearable="clearable"
		:error-count="3"
		:error-messages="errors || []"
		:item-text="nativeName ? 'textNative' : 'text'"
		@input="onInput($event)"
		@change="onChange($event)"
	/>
</template>

<script>
import { reduce } from 'lodash'
import locales from '@/datasources/locales'

export default {
	props: {
		errors: {
			type: Array,
			default: () => [],
		},
		preferred: {
			type: Array,
			default: () => [],
		},
		disabled: Boolean,
		label: String,
		value: [String, Array],
		clearable: Boolean,
		multiple: Boolean,
		nativeName: Boolean,
	},
	data() {
		return {
			items: [],
		}
	},
	computed: {
		selected() {
			return this.value
		},
	},
	mounted() {
		this.buildItems()
	},
	methods: {
		onInput(event) {
			this.$emit('input', event)
		},
		onChange(event) {
			this.$emit('change', event)
		},
		buildItems() {
			const items = []
			if (this.preferred.length) {
				items.push({ header: 'Preferred' })
				this.preferred.forEach((code) => {
					const locale = locales[code]

					items.push({
						text: locale.name,
						textNative: locale.nativeName,
						value: code,
					})
				})
				items.push({ divider: true })
				items.push({ header: 'Others' })
			}

			this.items = reduce(locales, (acc, value, code) => [...acc, {
				text: value.name,
				textNative: value.nativeName,
				value: code,
			}], items)
		},
	},
}
</script>
